import { useMemo } from "react";

import type { ScreenMembersOnResetPasswordError } from "@auth0/auth0-acul-js";
import ResetPasswordErrorInstance from "@auth0/auth0-acul-js/reset-password-error";

export const useResetPasswordErrorManager = () => {
  const resetPasswordErrorInstance = useMemo(
    () => new ResetPasswordErrorInstance(),
    []
  );

  const { screen, transaction } = resetPasswordErrorInstance;
  const { texts, data } = screen;

  return {
    resetPasswordErrorInstance,
    texts: (texts || {}) as ScreenMembersOnResetPasswordError["texts"],
    errors: resetPasswordErrorInstance.getError(),
    prefilledIdentifier: data?.username || "",
    loginLink: screen.links?.login || null,
    transactionState: transaction.state || "",
    resetPasswordLink: screen.links?.reset_password || null,
  };
};
